import { Component } from '@angular/core';
import { AlertComponent } from '../alert/alert.component';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs';
import { SharedService } from '../../services/shared/shared.service';
import { NavigationService } from '../../services/navigation/navigation.service';
import { environment } from '../../../environments/environment';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { CryptoService } from '../../services/crypto/crypto.service';
import { DashboardSignalKey, SignalService } from 'app/services/signal/signal.service';
import { SidebarService } from 'app/services/sidebar/sidebar.service';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    templateUrl: 'sidebar.component.html',
    styleUrl: 'sidebar.component.css',
    imports: [AlertComponent, RouterLink, CommonModule]
})
export class SidebarComponent
{
    nb_clos!:number | undefined
    nb_en_cours!:number | undefined
    nb_message_non_lus!:number | undefined
    nb_document_non_lus!:number | undefined
    nb_message!:number | undefined
    nb_document!:number | undefined
    nb_need_edit!:number
    isDetailsDossierVisible:boolean = false
    ref!:string|null
    type_ref!:string|null
    idUser!:number
    id_dossier!:number
    lien_guide:string = environment.LINK_GUIDE
    refs_list:string[] = []
    
    // proxy pour assigner directement les propriétés
    state!: Record<DashboardSignalKey, number | null>
    
    constructor
    (
        private sidebarService: SidebarService,
        private sharedService: SharedService,
        private router: Router,
        private navigationService: NavigationService,
        private dashboardService: DashboardService,
        private cryptoService: CryptoService,
        private signalService: SignalService
    ) 
    {
        this.idUser = this.sharedService.getIdUser()

        this.initProxy()
        this.getData()
        this.removeRef()
    }
    
    initProxy()
    {
        this.state = new Proxy(
            {}  as Record<DashboardSignalKey, number | null>,
            {
                set: (target, prop:string, value) => 
                {
                    if(prop in this.signalService.data)
                    {
                        this.signalService.setData(prop as DashboardSignalKey, value)
                        target[prop as DashboardSignalKey] = value
                        return true
                    }
                    else
                    {
                        console.warn(`Property ${prop} is not in SignalDataDashboard`)
                        return false
                    }
                },
                get: (target, prop:string) => 
                {
                    if(prop in this.signalService.data)
                    {
                        return this.signalService.getSignal(prop as DashboardSignalKey)()
                    }
                    return undefined
                }
            }
        )
    }

    ngOnInit()
    {
        this.removeRef()
        this.init()
    }

    ngAfterViewInit()
    {
        this.highlightSidebar()

        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            this.init()
        })
    }

    init()
    {
        this.ref = this.sharedService.getParam("ref")?.toString() || ""

        this.setTypeRef()
        this.highlightSidebar()
        this.setIsDetailsDossierVisible()
        
        this.id_dossier = Number(this.sharedService.getParam("id_dossier"))

        if( window.innerWidth < 1400 ) this.sharedService.hideSidebar()
    }

    highlightSidebar()
    {
        const route_split = this.router.url.split("/")[1]
        const url_end = route_split.startsWith("tableau-de-bord") || route_split.length == 0
            ? "dashboard"
            : this.router.url.split("/")[1] 

        this.removeHighlight()

        document.querySelector(`.${url_end}`)?.classList.add("active","collapsed")
    }

    removeHighlight()
    {
        Array.from(document.querySelectorAll(".nav-menu-item-group"))
            .map( e => e.classList.remove("active"))
    }

    setActive(event:Event)
    {
        this.removeHighlight()

        {(event.currentTarget as HTMLElement)?.classList.add("active")}
    }

    setTypeRef()
    {
        this.type_ref = sessionStorage.getItem("type_ref") || null
    }

    setIsDetailsDossierVisible()
    {
        this.isDetailsDossierVisible = this.ref  ? true : false
    }

    removeRef()
    {
        sessionStorage.removeItem("ref")
    }

    getData()
    {
        this.sidebarService.getData(this.idUser).subscribe(data => {
            if(data)
            {
                this.state.nb_clos = data[0]?.NB_CLOS
                this.state.nb_en_cours = data[0]?.NB_EN_COURS
                this.state.nb_message_non_lus = data[0]?.NB_MESSAGE_NON_LUS
                this.state.nb_document_non_lus = data[0]?.NB_DOCUMENT_NON_LUS
                this.state.nb_message = data[0]?.NB_MESSAGE
                this.state.nb_document = data[0]?.NB_DOCUMENT
            }
        })

        this.getRefDossiers()
    }

    getRefDossiers()
    {
        this.dashboardService.getRefDossiers(this.idUser).subscribe(data => {
            if(data) this.refs_list = data.map(row => row.REF)
        })
    }

    goTo(urlEnd:string)
    {
        this.navigationService.navigateByURL(`tableau-de-bord/${urlEnd}`, [null])
    }

    goToSaisine(ref:string|null)
    {   
        if(ref) this.navigationService.navigateByURL(`dossiers/saisine/ref_${ref}`, [null])
    }

    async newSaisine(id_user:number)
    {       
        const url = environment.LINK_SAISINE

        this.cryptoService.encryptData(id_user.toString()).subscribe(data => {
            const parameterValue = `?data=${data.iv}:${data.encrypted}`
            window.open(url+parameterValue, '_blank')
        })
    }

    displaySidebar()
    {
        this.sharedService.hideSidebar()
    }

    switchToTabletMode()
    {
        return this.sharedService.switchToTabletMode()
    }
}